import { toggle } from 'slidetoggle';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

function mobileMenuActivate() {
    const mediaQuery = '(max-width: 768px)';
    const mediaQueryList = window.matchMedia(mediaQuery);

    const menuToggle = document.querySelector(".menu-toggle");
    const mobileNav = document.getElementById("mobile-nav");
    

    mediaQueryList.addEventListener('change', event => {
        if (event.matches) { // < 768px
            menuToggle.classList.add("active")
            mobileNav.classList.add("active")
        } else { // > 768px
            menuToggle.classList.remove("active");
            mobileNav.classList.remove("active");
        }
    });
}

// sets a custom property for the height of the viewport accounting for the browser address bar
function setVh() {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}

// Mobile menu functionality
function clickBurger() {
    const siteHeader = document.querySelector('.site-header');
    const headerNav = document.querySelector(".header__nav");
    const targetButton = document.querySelector(".menu-toggle");
    const menu = document.getElementById("mobile-nav");
    const menuLinks = menu.querySelectorAll('a')
    // const innerMenu = document.querySelector('.mobileMenus');
	let isClosed = true;

	function burgerTime() {
		if (isClosed === true) {
            disableBodyScroll(menu);
            siteHeader.classList.add('open');
            headerNav.classList.add('toggled');
            targetButton.classList.remove('active');
            targetButton.classList.add('closed-burger');
            targetButton.setAttribute('aria-expanded', 'true');
            targetButton.setAttribute('aria-label', 'Close menu');
            menu.classList.remove('active', 'closed-menu');
            menu.classList.add('open-menu');
            menuLinks.forEach((link) => {
                link.setAttribute('tabindex', '0');
            });
			isClosed = false;
		} else {
            enableBodyScroll(menu);
            siteHeader.classList.remove('open');
            headerNav.classList.remove('toggled');
            targetButton.classList.remove('closed-burger');
            targetButton.setAttribute('aria-expanded', 'false');
            targetButton.setAttribute('aria-label', 'Open menu');
            menu.classList.remove('open-menu');
            menu.classList.add('closed-menu');
            menuLinks.forEach((link) => {
                link.setAttribute('tabindex', -1);
            });
			setTimeout(() => {
                targetButton.classList.add('active');
			}, 200);
			setTimeout(() => {
                menu.classList.add('active');
			}, 300);
			isClosed = true;
		}
	}

    document.addEventListener("keyup", (event) => {
        if (event.key === 27) { // escape key maps to key `27`
            enableBodyScroll(menu);
            siteHeader.classList.remove('open');
            headerNav.classList.add('toggled');
            targetButton.classList.remove('closed-burger');
            targetButton.classList.add('open-burger');
            targetButton.setAttribute('aria-expanded', 'false');
            targetButton.setAttribute('aria-label', 'Open menu');
            menu.classList.remove('open-menu');
            menu.classList.add('closed-menu');
            headerNav.classList.remove('toggled');
            menu.querySelectorAll('a').setAttribute('tabindex', '-1');
			isClosed = true;
		}
	});

    targetButton.addEventListener("click", burgerTime);
}

// adds sub menu functionality to mobile menu
function mobileMenuSub() {
    const mobileMenu = document.getElementById("mobile-menu");
    const subMenu = mobileMenu.querySelectorAll('.sub-menu');
    const menuItem = mobileMenu.querySelectorAll('.menu-item-has-children > a');

    // set display none on sub menu
    subMenu.forEach((item) => {
        item.style.display = 'none'; // eslint-disable-line no-param-reassign
    });

    // add elemnt after each menu item
    menuItem.forEach((item) => {
        const indicator = document.createElement('span');
        indicator.classList.add('headerNavMobile__itemMarker');
        indicator.setAttribute('aria-hidden', 'true');

        item.appendChild(indicator);

        item.addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.target;
            const targetSibling = target.nextElementSibling;
            target.classList.toggle('open');

            // ensure that the .sub-menu does not have a top or bottom margin set to avoid jankiness
            toggle(targetSibling, {
                miliseconds: 400,
                transitionFunction: 'ease',
            });
        });
    });

}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {
	mobileMenuActivate();
    setVh();
	clickBurger();
	mobileMenuSub();
};

export default init;
